import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../micromate-learn-web/src/environments/environment';
import {User} from '../../components/chatbot/User';

@Injectable({
    providedIn: 'root'
})
export class LoggerRessource {

    constructor(private http: HttpClient) {
    }

    public logFrontendInfoToBackend(info: string, authenticatedUser?: User): void {

        const data = {
            localUserId: LoggerRessource.getLocalUserId(),
            sub: authenticatedUser?.sub,
            data: `LEARN: ${info}, localTime: ${new Date().toISOString()}\``
        };

        this.http.post(`${environment.serverUrl}/api/frontend-logs`, data, {responseType: 'text'}).subscribe();
    }

    public static getLocalUserId(): string {
        let userId = localStorage.getItem('micromate_logger_user_id');
        // eslint-disable-next-line no-null/no-null
        if (userId === null) {
            userId = Math.random().toString();
            localStorage.setItem('micromate_logger_user_id', userId);
        }

        return userId;
    }
}
